import { createStore } from "vuex";

const localStorageKey = 'DJsdfg-2352LLDSF-dfg*2fds#jis2777';

export default createStore({
    state: {
        isAuthenticated: false,
        depot: '',
        name: '',
        empresa: '',
        ruc: '',
        token: '',
        ruta: '',
        columnasVisibles: {
            plannedtime: true,
            actualtime: true,
            min: true
        }
    },
    getters: {

    },
    mutations: {
        setIsAuthenticated(state, value) {
            state.isAuthenticated = value;
            localStorage.setItem(localStorageKey, JSON.stringify(state));
        },

        setDepot(state, value) {
            state.depot = value;
            localStorage.setItem(localStorageKey, JSON.stringify(state));
        },

        setEmpresa(state, value) {
            state.empresa = value;
            localStorage.setItem(localStorageKey, JSON.stringify(state));
        },

        setName(state, value) {
            state.name = value;
            localStorage.setItem(localStorageKey, JSON.stringify(state));
        },

        setRuc(state, value) {
            state.ruc = value;
            localStorage.setItem(localStorageKey, JSON.stringify(state));
        },

        setToken(state, value) {
            state.token = value;
            //localStorage.setItem(localStorageKey, JSON.stringify(state));
        },

        setRuta(state, routeName) {
            state.ruta = routeName;
            localStorage.setItem(localStorageKey, JSON.stringify(state));
        },

        toggleColumnVisibility(state, columnName) {
            state.columnasVisibles[columnName] = !state.columnasVisibles[columnName];
            localStorage.setItem(localStorageKey, JSON.stringify(state));
        },

        setColumnasVisibles(state, columnasVisibles) {
            state.columnasVisibles = columnasVisibles;
            localStorage.setItem(localStorageKey, JSON.stringify(state));
        },

        initializeStateFromLocalStorage(state) {
            const storedState = localStorage.getItem(localStorageKey);
            if (storedState) {
                Object.assign(state, JSON.parse(storedState));
            }
        }
    },
    actions: {
        initializeStateFromLocalStorage({ commit }) {
            commit('initializeStateFromLocalStorage');
        }
    }
})